import { BaseEntryScope } from '#packages/apilib';
import { EditorAPIKey, WorkspaceApiKey } from '#packages/apis';
import { createHiddenElementsPrivateApi } from './privateApi';
import { HiddenElementsStore } from './hiddenElementsStore';

export class HiddenElementsScope extends BaseEntryScope {
  workspace = this.useDependency(WorkspaceApiKey);
  editorAPI = this.useDependency(EditorAPIKey);

  privateApi = this.declareApi(createHiddenElementsPrivateApi);
  store = this.declareStore(HiddenElementsStore);
}
